import { LoginActionType } from './ActionTypes';
const initialState = {
  applicantData:null,
};
const LoginReducer = (state = initialState, { type, payload } = {}) => {
  if(type === LoginActionType.setApplicantData){
    return {
      ...state,
      applicantData:payload
    };
  }else{
    return state;
  }
};
export default LoginReducer;
